import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import businessSavingAccountImage from "../../assets/static/personal/meeting_profiles.png";

function Njangie() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Njangie Account? We’ve got you covered."
        description="Kontriman provides several ways to assist you with your njangie account – through our help center, chat support, and email. Access the support you need, whenever and wherever you need it."
        imageUrl={FlightImage}
      />
      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Njangie Account</h1>
                  <p>
                    Our Njangie Account is designed to support traditional group
                    savings and lending practices. It empowers communities and
                    groups to pool resources, rotate funds, and build financial
                    discipline through trust and shared goals.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>Group savings and contribution tracking</li>
                    <li>Rotational payout and loan management</li>
                    <li>Transparent record-keeping and reporting</li>
                    <li>Mobile and online access for members</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Registered Njangie group or association</li>
                    <li>Group constitution or agreement</li>
                    <li>List of executive members with valid ID</li>
                    <li>Minimum number of members: 5</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Open Njangie Account
                    </Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={businessSavingAccountImage}
                  alt="Njangie Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Njangie;
